var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhistleSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whistle-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16c0 0.825-0.675 1.5-1.5 1.5s-1.5-0.675-1.5-1.5 0.675-1.5 1.5-1.5 1.5 0.675 1.5 1.5zM30.25 12.894l9.375 7.5c0.419 0.337 0.5 0.95 0.175 1.381l-4.888 6.519c-0.3 0.406-0.856 0.519-1.294 0.269l-9.4-5.375c-4.712 7.088-14.794 7.613-20.406 2-4.094-4.094-4.881-10.238-2.375-15.125-0.9-0.738-1.438-1.856-1.438-3.063 0-2.206 1.794-4 4-4 1.2 0 2.306 0.556 3.063 1.469 4.081-2.1 9.025-1.925 12.938 0.581l5.413 3.975c0.331 0.262 0.456 0.706 0.319 1.106l-0.637 1.844c-0.069 0.2-0.006 0.419 0.163 0.556l1.575 1.262c0.163 0.131 0.387 0.144 0.569 0.037l1.712-1.012c0.363-0.213 0.813-0.181 1.137 0.075zM5.344 5.519c-0.362-0.331-0.844-0.519-1.344-0.519-1.106 0-2 0.894-2 2 0 0.506 0.206 0.963 0.525 1.325 0.95-1.287 1.706-1.994 2.819-2.806zM17.5 16c0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5 2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistleSolid);
export default __webpack_public_path__ + "static/media/whistle-solid.e82d69b5.svg";
export { ForwardRef as ReactComponent };